<script setup lang="ts">
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import Tabs from 'primevue/tabs';
import { ref, watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';

definePage({
  name: 'account',
});

const route = useRoute();
const activeTab = ref<string>(route.path);

// Keep tab in sync with route
watch(
  () => route.path,
  (newPath) => {
    activeTab.value = newPath;
  },
);

const items = [
  {
    label: 'Profile',
    route: '/account/profile',
    icon: 'pi pi-user',
  },
  {
    label: 'Password',
    route: '/account/password',
    icon: 'pi pi-lock',
  },
  {
    label: 'Preferences',
    route: '/account/preferences',
    icon: 'pi pi-cog',
  },
  {
    label: 'Subscription',
    route: '/account/subscription',
    icon: 'pi pi-credit-card',
  },
];

const router = useRouter();

function handleTabClick(route: string) {
  activeTab.value = route;
  router.push(route);
}
</script>

<template>
  <div class="account-container p-6">
    <h1 class="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
      Account
    </h1>

    <div class="bg-white rounded-lg shadow">
      <Tabs v-model:value="activeTab as string" class="overflow-x-auto">
        <TabList>
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
            @click="() => handleTabClick(tab.route)"
          >
            <div class="flex items-center gap-2 text-inherit">
              <i :class="tab.icon" />
              <span>{{ tab.label }}</span>
            </div>
          </Tab>
        </TabList>
      </Tabs>
      <RouterView />
    </div>
  </div>
</template>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
